import React from "react";
import { Line } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import {
  Chart as ChartJS,
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);

const colorMap = {
  0: "#EF4444",
  1: "#F97316",
  2: "#F59E0B",
  3: "#84CC16",
  4: "#10B981",
  5: "#06B6D4",
  6: "#3B82F6",
  7: "#A855F7",
  8: "#EC4899",
};

export const IntensityLineChart = ({ card, index }) => {
  const { t } = useTranslation("ActivityMain");
  const labels = card.actualByYear.map((y) => y.year);

  const intensityValues = card.actualByYear.map((a, i) => {
    const actual = Number(a.value);
    const denom = Number(card.denominatorByYear[i]?.value);
    if (!actual || !denom) return null;
    return Number((actual / denom).toFixed(3));
  });

  const data = {
    labels,
    datasets: [
      {
        label: `tCO2e / ${card.denomLabel}`,
        data: intensityValues,
        borderColor: colorMap[index],
        backgroundColor: colorMap[index],
        tension: 0,
        pointRadius: 4,
        fill: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#ccc", // ⭐ 無底色
        displayColors: false, // ⭐ 移除 label 顏色方塊
        borderWidth: 0,
        titleColor: "#000", // 可自訂文字顏色
        bodyColor: "#000",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: t("Year"),
          color: colorMap[index],
        },
        grid: { color: "#f0f0f0" },
      },
      y: {
        title: {
          display: true,
          text: `tCO2e / ${card.denomLabel}`,
          color: colorMap[index],
        },
        grid: { color: "#f0f0f0" },
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "140px" }}>
      <Line data={data} options={options} />
    </div>
  );
};
